export default [
  { code: "919", name: "財團法人創世社會福利基金會" },
  { code: "2588", name: "社團法人中華民國失智者照顧協會" },
  { code: "6274", name: "中華民國災難救援協會" },
  { code: "6988", name: "中華民國癌友新生命協會" },
  { code: "7088", name: "中華民國關懷生命協會" },
  { code: "8585", name: "財團法人台灣兒童暨家庭扶助基金會" },
  { code: "25885", name: "財團法人伊甸社會福利基金會" },
  { code: "88432", name: "財團法人喜憨兒社會福利基金會" },
  { code: "885521", name: "財團法人中華民國兒童福利聯盟文教基金會" },
  { code: "92131", name: "社團法人台灣愛貓協會" }
];
